import React from "react"
import classNames from "classnames"
import { Card as AntdCard } from "antd"
import styles from "./Card.module.css"

export const Card = ({ className, ...rest }) => {
  return <AntdCard className={classNames(className, styles.card)} {...rest} />
}
